import React from 'react';
import { Popover } from 'antd';
import { URAvatarGroup } from '../../../../shared/widgets/avatarGroup';
import { URStatusDot } from '../../../../shared/widgets/avatarGroup/statusDot';
import { userStatusColor } from '../../../../base/callService/common';
import teamImg from "../../../../styles/images/TeamProfilePic.png"
import teamIcn from "../../../../styles/images/teamimg.svg";
import singleIcon from "../../../../styles/images/Welaunch_Profile_Pic.svg";
import pstn from "../../../../styles/images/nonamecall.svg";

type PopoverModuleProps = {
  popOverValues: any;
  randomColor: any;
  value:any;
}

export default function PopoverModule({ popOverValues,randomColor,value}: PopoverModuleProps) {
  let colorValue = value?'xsmall':'small';

  return (
    <>
      <Popover placement="bottomLeft" trigger="click" overlayClassName={value?"FavouriteDetailscontact":"contactDetailsppCall"}>
        <div>
          {  popOverValues?.is_blocked  === 1? <URAvatarGroup className={`lefts size40 mr12`}
                            profileInfo={<> 
                           <img src={singleIcon} alt="team icon" />
                           </>
                            }/>:   
          popOverValues?.team_id ?   <URAvatarGroup className={`lefts size40 mr12`}
                            profileInfo={<> 
                            {popOverValues?.profile_image_url !== ""? 
                             <img src={popOverValues?.profile_image_url} alt="team icon" />:
                             <span className="teamImg"><img src={teamIcn} alt="team icon" /></span> 
                             }
                           </>
                            }/>:
      
          <URAvatarGroup className={value?`lefts size40 mr12 colorBG${randomColor}`:`lefts size38 mr8 colorBG${randomColor}`}
            profileInfo={
              (popOverValues.serviceType === 'GroupCall') ?
              <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>   
                :
                (<>
                  {(popOverValues?.ImageURL !== null && popOverValues?.ImageURL !== "") ? <img src={popOverValues?.ImageURL} alt="team icon" /> :

                    (
                      popOverValues.first_name ?
                        <span >{popOverValues?.first_name?.charAt(0).toUpperCase() + popOverValues?.last_name?.charAt(0).toUpperCase()}</span>
                        :

                        <img src={pstn} alt="" />
                    )
                  }
                  <URStatusDot className={userStatusColor(popOverValues?.user_status, colorValue)} />

                </>)
            } /> }

        </div>
      </Popover>
    </>
  );
}